import * as ng from 'angular';
import {IDocToConserveStatistics} from '../../../../commons/interfaces/IDocToConserveStatistics';
import {FileService} from '../../../../services/file.service';
import {ArchiSmallServices} from '../../../../services/archismall.service';

class VerificaStatoConservazioneController implements ng.IController {
  static $inject: string[] = [
    '$scope',
    '$rootScope',
    'ArchiSmallServices',
    '$uibModal',
    '$state',
    'FileService',
    '$stateParams',
  ];

  constructor(
    private $scope: {
      docsToConserve: IDocToConserveStatistics[];
      documentsId: string[];
      label: string[];
      colours: string[];
      valueStatusDocs: number[];
      keyStausDocs: string[];
      objStatusDocs: { [key: number]: number };
      objDocIds: { [key: number]: string[] };
      user: IDocToConserveStatistics;

      // serve per evitare errori di typescript su parametri non definiti, di default ogni parametro è any
      [key: string]: any
    },
    private $rootScope: any,
    private ArchiSmallServices: ArchiSmallServices,
    private $uibModal: ng.ui.bootstrap.IModalService,
    private $state: any,
    private fileService: FileService,
    private $stateParams: ng.ui.IStateParamsService,
  ) {
    $scope.pageHeader = 'Verifica stato conservazione';

    $scope.loadData = async () => {
      try {
        if ($stateParams.userId !== '') {
          $scope.userId = $stateParams.userId;
        } else {
          $scope.userId = $rootScope.currentUser().user_id;
        }
        const response = await ArchiSmallServices.getDocToConserveStatisticsItemsUser($scope.userId);
        $scope.docsToConserve = JSON.parse(JSON.stringify(response));
        $scope.objStatusDocs = {1: 0, 2: 0, 7: 0, 10: 0};
        $scope.docsToConserve
          .forEach(value => {
            $scope.objStatusDocs[value.status] = ($scope.objStatusDocs[value.status] || 0) + value.count;
            $scope.valueStatusDocs = Object.values($scope.objStatusDocs);
          });

        $scope.objDocIds = {1: [], 2: [], 7: [], 10: []};
        $scope.docsToConserve
          .forEach(value => {
            $scope.objDocIds[value.status].push(...value.docIds);
          });
        $scope.label = ['In coda', 'Conservati', 'In errore', 'Da conservare'];
        $scope.colours = ['#2B77BA', '#4cae4c', '#FF0000', '#FFC107'];

        $scope.consumiData = [
          {'class': 'in-coda-bgrd', 'label': 'In coda', 'status': $scope.valueStatusDocs[0]},
          {'class': 'conservati-bgrd', 'label': 'Conservati', 'status': $scope.valueStatusDocs[1]},
          {'class': 'in-errore-bgrd', 'label': 'In errore', 'status': $scope.valueStatusDocs[2]},
          {'class': 'da-conservare-bgrd', 'label': 'Da conservare', 'status': $scope.valueStatusDocs[3]},
        ];

        $scope.options = {
          onClick: function (event, elements) {
            if (!elements.length) {
              return;
            }
            const mapping = [1, 2, 7, 10];
            const index = mapping[elements[0]._index];
            $scope.viewDocumentIds($scope.objDocIds[index]);

          },
          tooltips: {
            callbacks: {
              label: function (tooltipItem, data) {
                const label = data.labels[tooltipItem.index] || '';
                const value = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
                return `${value} documents`;
              }
            }
          }
        };
      } catch (error) {
        console.error(error);
      }
    };

    $scope.loadData();

    $scope.viewDocumentIds = (listIds: string[]) => {
      const documentsId = listIds;
      let CreateModal = $uibModal.open({
        animation: true,
        component: 'viewDocIdDocumentModalComponent',
        windowClass: 'center-modal',
        backdrop: 'static',
        keyboard: false,
        resolve: {
          documentsId: () => {
            return documentsId;
          },
        }
      });
      CreateModal.result
        .catch(error => {
          console.error('Error:', error);
        })
        .finally(() => {
          $state.reload();
        });
    };

    $scope.exportCsv = () => {
      let CreateModal = $uibModal.open({
        animation: true,
        component: 'workerDownloadCsvClientiModalComponent',
        windowClass: 'center-modal',
        backdrop: 'static',
        keyboard: false,
        resolve: {
          settings: {
            user: $rootScope.currentUser().sub,
            key: 'exportCsvData',
          }
        }
      });
      CreateModal.result.catch(error => {
        console.error('Error:', error);
      })
        .finally(() => {
          $state.reload();
        });
    };
  }
}

export const VerificaStatoConservazioneComponent: ng.IComponentOptions = {
  template: require('./verifica-stato-conservazione.html'),
  controller: VerificaStatoConservazioneController
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/conservazione/verifica-stato-conservazione/verifica-stato-conservazione.ts